import React from "react";
import { companyInfo } from "../../data/general";

interface StickyPropertyCtaProps {
  onEnquire: () => void;
}

const StickyPropertyCta: React.FC<StickyPropertyCtaProps> = ({ onEnquire }) => {
  const telHref = `tel:${companyInfo.phone.replace(/[^\d+]/g, "")}`;
  const whatsAppNumber = companyInfo.phone.replace(/\D/g, "");
  const whatsAppHref = `https://wa.me/${whatsAppNumber}`;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-text-obsidian text-white border-t border-solid border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]">
      <div className="grid grid-cols-3 divide-x divide-solid divide-white/10">
        <a
          href={telHref}
          className="flex flex-col items-center justify-center py-3 px-2 font-manrope text-xs uppercase tracking-wider hover:bg-white/10 transition-colors"
        >
          <span className="font-teko text-lg leading-none mb-1">☎</span>
          Call
        </a>
        <a
          href={whatsAppHref}
          target="_blank"
          rel="noreferrer"
          className="flex flex-col items-center justify-center py-3 px-2 font-manrope text-xs uppercase tracking-wider hover:bg-white/10 transition-colors"
        >
          <span className="font-teko text-lg leading-none mb-1">💬</span>
          WhatsApp
        </a>
        <button
          type="button"
          onClick={onEnquire}
          className="flex flex-col items-center justify-center py-3 px-2 font-manrope text-xs uppercase tracking-wider hover:bg-brand-yellow hover:text-text-obsidian transition-colors"
        >
          <span className="font-teko text-lg leading-none mb-1">✉</span>
          Enquire
        </button>
      </div>
    </div>
  );
};

export default StickyPropertyCta;
